import type { RootState } from '@store';

export const registrationSelector = (state: RootState) => state.registration;
